var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-12" },
    [
      _c("hr", {
        staticClass: "w-px bg-n-gray border border-n-gray w-full mt-12 mb-12",
      }),
      _vm._v(" "),
      _c("div", { staticClass: "flex flex-col md:flex-row mb-6 md:mb-0" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.resources.length > 0
          ? _c("div", { staticClass: "w-full md:w-2/3" }, [
              _c(
                "div",
                { staticClass: "flex flex-col md:flex-row justify-end" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "button button__medium flex-auto md:flex-initial",
                      attrs: { to: { name: "resource-create" } },
                    },
                    [_vm._v("\n          Add a Resource\n        ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-0 md:ml-3 mb-3 md:mb-0" }),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "button button-secondary button__medium flex-auto md:flex-initial",
                      attrs: { to: { name: "resource-index" } },
                    },
                    [_vm._v("\n          View all\n        ")]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.resources.length < 1
        ? [
            _c(
              "div",
              { staticClass: "text-n-gray-dark text-2xl font-hairline" },
              [
                _vm._v(
                  "\n      Add your existing services, products, art, workshops and educational offerings--along with the inspiring stories behind your work--for\n      inclusion in "
                ),
                _c(
                  "NewTabA11y",
                  { attrs: { href: "https://letsreimagine.org/resources" } },
                  [_vm._v("Reimagine Community Resources")]
                ),
                _vm._v(".\n      Learn more "),
                _c(
                  "NewTabA11y",
                  {
                    attrs: {
                      href: "https://help.letsreimagine.org/hc/en-us/articles/360041714752-What-is-Reimagine-Community-Resources-",
                    },
                  },
                  [_vm._v("here")]
                ),
                _vm._v(".\n    "),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-6" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "button button__medium flex-auto md:flex-initial",
                    staticStyle: { width: "320px" },
                    attrs: { to: { name: "resource-create" } },
                  },
                  [_vm._v("\n        Create your first resource!\n      ")]
                ),
              ],
              1
            ),
          ]
        : [
            _c(
              "div",
              { staticClass: "pl-5 flex flex-wrap" },
              _vm._l(_vm.resources, function (resource, i) {
                return _c(
                  "div",
                  { key: resource.id, staticClass: "w-full md:w-1/3" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "pb-6",
                        class: _vm.cardContainerClasses(i),
                      },
                      [_c("ResourceCard", { attrs: { resource: resource } })],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-full md:w-1/3" }, [
      _c(
        "h2",
        {
          staticClass:
            "text-2.5xl font-sans-bold text-n-gray-dark font-hairline mb-6",
        },
        [_vm._v("\n        Resources\n      ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }